export const isValidMobileNumber = (number) => {
    const mobileRegex = /^\d{10,11}$/;
    return mobileRegex.test(number);
  };


  